import liveDataLoader from '../loading/liveDataLoader';
import apiService from './api/ApiService';
import { t } from '../services/i18nService';
import alertService from '../services/AlertService';

import storeManager from '../store/StoreManager';
import branchRuleActions from '../actions/BranchRuleActions';
import sessionActions from './../actions/SessionActions';
import sessionConstants from '../constants/SessionConstants';


async function handleEvaluationDone(result) {
    if (!result.success) {
        return Promise.reject({
            errorType: 'Evaluation failed',
            response: result,
            error: 'Evaluation failed with success false',
        });
    }

    storeManager.dispatch(branchRuleActions.setActionInProgress(undefined));
    storeManager.dispatch(branchRuleActions.setHasEvaluated(true));

    // After branch rules evaluation, the Question Set has to be augmented with the target section.
    await liveDataLoader.loadQuestionSet();
    await liveDataLoader.loadSavedResponsesForExam();
    storeManager.dispatch(sessionActions.toggleNavigationLock(false));
    return true;
}

function setEvaluationInProgress(progressAction) {
    storeManager.dispatch(
        branchRuleActions.setActionInProgress(progressAction),
    );

    storeManager.dispatch(
        sessionActions.toggleNavigationLock(true, sessionConstants.LOCK.EVALUATION_IN_PROGRESS, null),
    );
}

function handleEvaluationFailure() {
    alertService.showAlert(t('deliver.evaluationFailed'), { timeout: 'none' });
    storeManager.dispatch(
        branchRuleActions.setActionInProgress(undefined),
    );
    storeManager.dispatch(
        sessionActions.toggleNavigationLock(false),
    );
}

async function evaluateSectionBranchRules(sectionId) {
    try {
        return await handleEvaluationDone(await apiService.evaluateBranchRules(sectionId));
    } catch (error) {
        handleEvaluationFailure();
        throw error;
    }
}

const branchRuleService = {
    evaluateBranchRule() {
        setEvaluationInProgress(branchRuleActions.progressActions.EVALUATE_BRANCH_RULE);
        const { currentlyShown } = storeManager.getState();
        return evaluateSectionBranchRules(currentlyShown.sectionId);
    },
};

export default branchRuleService;
